type BrandKey =
  | "lojaanimale"
  | "lojafabula"
  | "lojafarm"
  | "lojaoffpremium"
  | "mariafilo"
  | "lojacrisbarros"
  | "null";

export const storedEnv = (localStorage.getItem('env') as BrandKey || null);

export const userToken = localStorage.getItem('userToken');
